import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useEffect } from "react";

interface ICalculateFeatureInput {
  calculateType: any;
  setCalculateType: any;
}

const useStyles = makeStyles({
  root: {
    marginLeft: "15px",
    marginTop: "25px",
  },
});

const CalculateFeatureInput = ({
  calculateType,
  setCalculateType,
}: ICalculateFeatureInput) => {
  const classes = useStyles();

  const calculateTypeList = [
    { id: "area", name: "Area" },
    { id: "studentCost", name: "Student Cost" },
  ];

  useEffect(() => {
    setCalculateType(calculateTypeList[0].id);
  }, []);

  const handleChange = (event: any) => {
    setCalculateType(event.target.value);
  };

  return (
    <FormControl
      variant="filled"
      fullWidth
      className={`${classes.root} form-control`}
    >
      <InputLabel id="calculateType">Calculate Type</InputLabel>
      {calculateType && (
        <Select
          labelId="calculateType"
          id="calculateType"
          value={calculateType}
          onChange={handleChange}
        >
          {calculateTypeList.map((value: any) => {
            return (
              <MenuItem value={value.id} key={value.id}>
                {value.name}
              </MenuItem>
            );
          })}
        </Select>
      )}
    </FormControl>
  );
};

export default CalculateFeatureInput;
